import styled, { css } from 'styled-components';

import WaveSVG from 'Public/graphics/waves/course-listing/wave-course-listing-hero.svg';

export const Container = styled.section`
    ${({ theme }) => css`
        position: relative;
        padding: 5rem 0 1rem;
        overflow: hidden;
        background-color: ${theme.colors.secondary.tints[1].hex};

        @media ${({ theme }) => theme.breakpoints.large.media} {
            padding: 7rem 0 1.5rem;
        }
    `}
`;

export const Heading = styled.h1`
    margin: 0;
`;

export const Wave = styled(WaveSVG)<{ $containerHeight: number }>`
    ${({ theme, $containerHeight }) => css`
        position: absolute;
        width: 76rem;
        height: 20rem;
        top: -3.5rem;
        left: -20rem;
        mask-image: linear-gradient(
            to bottom,
            black,
            rgba(0, 0, 0, 0.4) ${$containerHeight * 0.75}rem,
            transparent ${$containerHeight + 3.5}rem
        );

        @media ${theme.breakpoints.medium.media} {
            left: -10rem;
        }

        @media ${theme.breakpoints.large.media} {
            width: 100rem;
            top: -1.5rem;
            left: -4rem;
            mask-image: linear-gradient(
                to bottom,
                black,
                rgba(0, 0, 0, 0.4) ${$containerHeight * 0.75}rem,
                transparent ${$containerHeight + 1.5}rem
            );
        }

        @media ${theme.breakpoints.huge.media} {
            width: calc(100% + 10rem);
            height: auto;
            top: 0;
            left: -6rem;
        }
    `}
`;
